import arrayMove from 'array-move';
import React, { useEffect, useState } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
} from 'reactstrap';
import Button from 'reactstrap/lib/Button';
import { CONTENT_TYPE, ENV_TYPE } from '../../../../constants/abuddy.constants';
import { AWSelect, Back } from '../../../../helpers';
import { getContents } from '../../../../services/abuddy.service';
import Modal from '../../../RichMenuManagement/components/Modal';

const SortableItem = SortableElement(({ children, ...rest }) => (
  <li {...rest} style={{ listStyleType: 'none' }}>
    {children}
  </li>
));
const SortableList = SortableContainer(({ items, handleDelete }) => {
  return (
    <ul>
      {items.map((value, index) => (
        <SortableItem
          key={`item-${value.imageFlex || ''}`}
          index={index}
          className="mb-3"
        >
          <div style={{ cursor: 'move' }}>
            <Row>
              <Col
                style={{ display: 'flex' }}
                className="justify-content-end align-items-center"
                md="1"
              >
                <i className="iconm-Rearrange" />
              </Col>
              <Col md="9" style={{ marginTop: 20 }}>
                <FormGroup row>
                  <Col md="2" style={{ margin: 'auto' }}>
                    <Label htmlFor="orderNo">ลำดับที่{index + 1}</Label>
                  </Col>
                  <Col md="2">
                    <img
                      src={
                        process.env.REACT_APP_S3_URL + '/' + value.imageFlex ||
                        ''
                      }
                      alt=""
                      className="img-responsive"
                      width="100%"
                    />
                  </Col>
                  <Col md="6" style={{ margin: 'auto' }}>
                    <span>{value.name}</span>
                  </Col>
                  <Col md="2" style={{ margin: 'auto' }}>
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        return handleDelete(value);
                      }}
                    >
                      ลบ
                    </Button>
                  </Col>
                </FormGroup>
              </Col>
            </Row>
          </div>
          <hr />
        </SortableItem>
      ))}
    </ul>
  );
});

const SelectContentModal = ({ isOpen, onClose, callback, selected }) => {
  const [contentSelected, setContentSelected] = useState();
  const [contentOptions, setContentOptions] = useState([]);
  let [contentSelectedList, setContentSelectedList] = useState([]);
  const [isHandleSelectd, setIsHandleSelectd] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  useEffect(() => {
    if (
      selected &&
      selected.length !== 0 &&
      contentOptions.length !== 0 &&
      isHandleSelectd
    ) {
      let contentOptionsMock = contentOptions;

      const selectedIds = [];
      selected.map((value) => selectedIds.push(value.contentId));

      contentOptionsMock = contentOptions.filter((value) => {
        if (!selectedIds.includes(value._id)) {
          return value;
        }
      });
      setContentOptions(contentOptionsMock);

      for (const content of selected) {
        const contentOption = contentOptions.find(
          (value) => value._id === content.contentId,
        );
        if (contentOption) {
          contentSelectedList.push(contentOption);
        }
        setContentSelectedList(contentSelectedList);
      }

      setIsHandleSelectd(false);
    }
  }, [selected, contentOptions, isHandleSelectd]);

  const fetchContent = async () => {
    const params = {
      start: 0,
    };
    const response = await getContents(params);
    setContentOptions(response.data);
  };

  const onChange = (e) => {
    setContentSelected(e.target.value);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    contentSelectedList = arrayMove(
      contentSelectedList,
      oldIndex,
      newIndex,
    );
    setContentSelectedList(contentSelectedList);
  };

  const handleDelete = (value) => {
    contentOptions.push(value);
    setContentOptions(contentOptions);
    if (contentSelectedList.length === 1) {
      setContentSelectedList([]);
      return;
    }
    const newSelected = contentSelectedList.filter(
      (content) => content !== value,
    );
    setContentSelectedList(newSelected);
  };

  const onSelect = () => {
    if (!contentSelected) {
      return alert('กรุณาเลือก Content');
    }
    const content = contentOptions.find(
      (value) => value.name === contentSelected,
    );
    contentSelectedList.push(content);
    setContentSelectedList(contentSelectedList);

    const newContent = contentOptions.filter(
      (value) => value !== content,
    );
    setContentOptions(newContent);
    setContentSelected('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    callback([...contentSelectedList]);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} contentLabel="Example Modal">
      <Card className="SettingGuideModal_Component">
        <CardHeader>
          <div />
          <div>
            <strong className="center-block">เลือก Content</strong>
          </div>
        </CardHeader>
        <CardBody className="design-guide-card-body">
          <div className="body">
            <Row className="padding-side mr-bottom">
              <Col md="12">
                <strong>Content</strong>
                <Row className="ml-2">
                  <AWSelect
                    type="select"
                    name="actionType"
                    value={contentSelected}
                    onChange={onChange}
                  >
                    <option value="">เลือก Content</option>
                    {contentOptions.map((value) => {
                      return (
                        <option key={value.name} value={value.name}>
                          {value.name} {value.contentType ? `(${value.contentType})`: null}
                        </option>
                      );
                    })}
                  </AWSelect>
                  <Button className="btn-select-sub-cat" onClick={onSelect}>
                    เลือก
                  </Button>
                </Row>
              </Col>
            </Row>
            <div className="animated fadeIn actionDetail-view">
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      <Form
                        action=""
                        method="post"
                        encType="multipart/form-data"
                        className="form-horizontal"
                      >
                        <SortableList
                          items={contentSelectedList}
                          onSortEnd={onSortEnd}
                          handleDelete={handleDelete}
                        />
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
          <CardFooter>
            <Button
              type="submit"
              className="submit-btn ml-1"
              onClick={handleSubmit}
            >
              <i className="iconm-Save"></i> Submit
            </Button>
            <Button
              onClick={() => {
                onClose();
              }}
              type="reset"
              style={{ marginLeft: '10px' }}
              className="back-btn"
            >
              <Back /> Back
            </Button>
          </CardFooter>
        </CardBody>
      </Card>
    </Modal>
  );
};

export default SelectContentModal;
